import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Block = ({ block }) => {
  switch (block.type) {
    case "h2":
      return <h2 className="mt-10 mb-3 text-xl sm:text-2xl font-bold text-ink tracking-tight">{block.text}</h2>;
    case "h3":
      return <h3 className="mt-6 mb-2 text-lg font-semibold text-ink">{block.text}</h3>;
    case "p":
      return <p className="mb-4 text-[15px] sm:text-base text-ink-muted leading-relaxed">{block.text}</p>;
    case "ul":
      return (
        <ul className="mb-5 space-y-2 pl-1">
          {block.items.map((it, i) => (
            <li key={i} className="flex gap-3 text-[15px] sm:text-base text-ink-muted leading-relaxed">
              <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
              <span>{it}</span>
            </li>
          ))}
        </ul>
      );
    case "links":
      return (
        <ul className="mb-5 space-y-2 pl-1">
          {block.items.map((it, i) => (
            <li key={i} className="flex gap-3 text-[15px] sm:text-base leading-relaxed">
              <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
              <span className="text-ink-muted">
                {it.label}:{" "}
                <a
                  href={it.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand font-medium hover:underline break-all"
                >
                  {it.href}
                </a>
              </span>
            </li>
          ))}
        </ul>
      );
    default:
      return null;
  }
};

export const LegalPage = ({ content }) => {
  useEffect(() => {
    document.title = `${content.title} — AN CONTAB AUDIT`;
    const meta = document.querySelector('meta[name="description"]');
    const prev = meta ? meta.getAttribute("content") : null;
    if (meta && content.metaDescription) meta.setAttribute("content", content.metaDescription);
    return () => {
      if (meta && prev) meta.setAttribute("content", prev);
    };
  }, [content]);

  return (
    <main className="bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm font-medium text-ink-muted hover:text-brand transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Înapoi la pagina principală
        </Link>

        <h1 className="mt-8 text-3xl sm:text-4xl font-extrabold tracking-tight text-ink">
          {content.title}
        </h1>
        {content.intro && content.intro !== content.title && (
          <p className="mt-3 text-base text-ink-muted font-medium">{content.intro}</p>
        )}
        <div className="mt-6 h-1 w-16 rounded-full bg-brand" />

        <div className="mt-8">
          {content.blocks.map((b, i) => (
            <Block key={i} block={b} />
          ))}
        </div>
      </div>
    </main>
  );
};
